import { notifications } from "@mantine/notifications";
import { Cubby } from "../stores/Cubby";

export const resetChannelOffers = (cubby: Cubby, uuid: string) => {
  if (cubby.channelOfferPendingAnInvoiceUuid == uuid) {
    console.log("uuid", uuid, "was finalized, nil all out now");
    cubby.setChannelOffers(null);
    cubby.setChannelOfferPendingAnInvoiceUuid(null);
    cubby.setModal(null);
  } else {
    console.log("hm, the channel offer pending an invoice uuid is different");
  }
};

export const handleChannelOfferLspError = (cubby: Cubby, data: any) => {
  console.log("handling channel offer lsp error", data);
  if (cubby.channelOfferPendingAnInvoiceUuid == data.channelOfferUuid) {
    notifications.show({
      color: "red",
      title: "Error",
      message: data.humanMessage,
    });
    cubby.resetChannelOffers(data.channelOfferUuid);
  } else {
    console.log("hm, the channel offer pending an invoice uuid is different");
  }
};

export const handleChannelOfferSelection = (
  cubby: Cubby,
  amount: number,
  isPrivate: boolean
) => {
  const offerUuid = cubby.channelOffers.data.uuid;
  console.log("asking rails about channel offer", offerUuid, amount);
  cubby.setChannelOffers(null);
  cubby.setChannelOfferPendingAnInvoiceUuid(offerUuid);
  cubby.cubbyFastInfo("get_invoice_for_channel_offer", {
    offerUuid: offerUuid,
    amountInSatoshis: amount,
    isPrivate: isPrivate,
  });
};
